module.exports = __webpack_public_path__ + "static/media/codeRainbowBalls.3c532009.gif";